export const FALLBACK_LOCALE = "en";

export const LOCALISATION_STATUS = {
  DEFAULT: "default",
  PUBLISHED: "published",
  DRAFT: "draft",
} as const;
